import React, { useState } from 'react';
import 'aos/dist/aos.css';
import smakonecup from '../Assets/SmakonecupLogo.webp';
import '../index.css'

function Top() {
  const [menuVisible, setMenuVisible] = useState(false);

  function toggleMenu() {
    setMenuVisible(!menuVisible);
  }

  return (
    <div className='m-0 px-[10px] text-[35px] relative w-full backdrop-blur-lg bg-gray-300/30 z-10 opacity-0 overflow-hidden'
        // data-aos="fade-down"
        // data-aos-offset="100"
        // data-aos-duration="1000"
        // data-aos-delay="0"
        // alt=""
    >
      <div className="grid grid-cols-3 font-[JakartaSans]">
        <div className='font-[600] text-left w-[500px]'>
            <img src={''} alt="" className='h-[70px] py-[5px] lg:py-0 lg:h-[100px] justify-start'/>
        </div>
      </div>

      {menuVisible && (
        <div className="block lg:hidden pb-4 top-full -mt-[10px] right-0 text-[20px]">
          <ul>
            <li className='menu-item text-white hover:text-purple-400 cursor-pointer' onClick={toggleMenu}>About</li>
          </ul>
        </div>
      )}
    </div>
  );
}

export default Top;
